'use strict'

import {get_single_select_choices_options} from './Choices.js';

function init_cf_search_dropdown_custom_fields(){
	document.querySelectorAll('select.cf_search_select').forEach(async cfSearchSelect => {
		const { default: Choices } = await import(/* webpackChunkName: "choices" */ 'choices.js')

		const choicesOptions = get_single_select_choices_options(
			cfSearchSelect,
			{
				searchEnabled: true,
				shouldSort: Boolean(cfSearchSelect.dataset.shouldSort),
				shouldSortItems: Boolean(cfSearchSelect.dataset.shouldSort)
			}
		)
		if(choicesOptions){
			cfSearchSelect.choices_instance = new Choices(cfSearchSelect, choicesOptions)
		}
	})
}


export {
	init_cf_search_dropdown_custom_fields
}
